module.exports = function(media) {
	media
    .controller('newVideoMediaoutcastController', newVideoMediaoutcastController)

	newVideoMediaoutcastController.$inject = ["fileReaderImage","$timeout","getSubstringBetween","API_URL","$interval","$state","$scope","getDataService", 'jQuery', '$stateParams','refreshtokenService','config','authtokenService','postDataService', 'alertService','serverError','$rootScope', 'reqursiveService','checkArray','$http','offlineError'];
	
  function newVideoMediaoutcastController(fileReaderImage,$timeout,getSubstringBetween,API_URL,$interval,$state,$scope,getDataService,jQuery, $stateParams,refreshtokenService,config, authtokenService,postDataService, alertService,serverError,$rootScope, reqursiveService, checkArray,$http,offlineError) {
    var vmnvm = this;
    var state = 'video';
    vmnvm.firstBind = false;
    vmnvm.data_grid = [];
    vmnvm.config = config;
    vmnvm.selectedTranscoding={value:vmnvm.config.videoUploadVersion}
    Dropzone.autoDiscover = false;
    vmnvm.editImageModal = false;
    vmnvm.upload_title = ''
    vmnvm.upload_signature = '';
    vmnvm.upload_description = '';
    vmnvm.tags = [];
    vmnvm.selectedImage = -1;
    vmnvm.uploadedThumb = false;
    vmnvm.thumbRequired = false;
    vmnvm.thumbsLoaded = {};
    vmnvm.custom_image = '';
    vmnvm.image = null;
    vmnvm.addSafety =config.addSafety;
    vmnvm.safe = null;
    vmnvm.checkedItems ={};
    vmnvm.videoSafeRequired = false;
    vmnvm.geoAllowance = config.geoRestrictions;
    vmnvm.allowCheckedItems = {};
    vmnvm.breaking = false;
    var displayRes = '-254x191.jpg';
    var loadedInterval;
    var geoAllowanceUpdateFunction = function() {
      for(var i=0; i<vmnvm.geoAllowance.length;i++) {
        vmnvm.allowCheckedItems[vmnvm.geoAllowance[i]._id] = false;
      }
    }
    geoAllowanceUpdateFunction();
    vmnvm.allowCheckedItems[vmnvm.geoAllowance[0]._id] = true;
    vmnvm.geoAllow = vmnvm.geoAllowance[0]._id;
    vmnvm.updateAllowance = function(allowance) {
      if(vmnvm.allowCheckedItems[allowance]) {
          putGeoAllowanceFunction(allowance);
      }
      geoAllowanceUpdateFunction();
      vmnvm.allowCheckedItems[allowance] = true;
    }
    var putGeoAllowanceFunction = function(allowance) {
      var url = API_URL + 'video/georestrictions/mediaoutcast/' + vmnvm.videoNew._id; 
        var updateDataPosts = {
          "allowance": allowance,
          "video_id": vmnvm.uploadVideoObj.id,
          "isUpdate": false
        }
        var putFunction = function() {
          $http.put(url , updateDataPosts)
          .success(function (data, status, headers) {
              alertService('success','Success ', data.message, 2000);
              vmnvm.geoAllow = allowance;
          })
          .error(function (data, status, header, config) {
            if(!window.navigator.onLine) {
              offlineError()
              geoAllowanceUpdateFunction();
              vmnvm.allowCheckedItems[vmnvm.geoAllow] = true;
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    putFunction();
                  }
                },
                function(error) {
                  // report something
                },
                function(progress) {
                  // report progress
              });
            }else if(status ==502) {
              serverError();
            } else {  
              alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
            
            }
            geoAllowanceUpdateFunction();
            vmnvm.allowCheckedItems[vmnvm.geoAllow] = true;
          });
        }
        putFunction();
    }
    vmnvm.chooseImage = function(index) {
      vmnvm.selectedImage = index;
      if(vmnvm.thumbs.length == vmnvm.thumbsLocked.length) {
        vmnvm.image = vmnvm.thumbsLocked[index] 
      } else {
        if(index==vmnvm.thumbs.length-1) {
          vmnvm.image = vmnvm.customThumbsLocked;
        } else {
            vmnvm.image = vmnvm.thumbsLocked[index];
        }
      } 
    }
    vmnvm.uploaded = false;
    vmnvm.onUpload = function() {
      var createVideo = function() {  
        postDataService.save({
          param1: state,
          param2: 'mediaoutcast'  
        }).$promise.then(function(data){
          vmnvm.videoNew = data.video;
        },function(error){
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                if(answer==200) {   
                  createVideo();
                }

              },
              function(error) {
                // report something
              },
              function(progress) {
                // report progress
            });
          }else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', error.data.error.message);
          }
        });
      }
      createVideo();
    }
    vmnvm.transcodingDone = function(videoObj) {
      vmnvm.uploadVideoObj = videoObj
      vmnvm.thumbsLocked = [];
      vmnvm.orientation = (vmnvm.uploadVideoObj.height>vmnvm.uploadVideoObj.width)? 'portrait': 'landscape';
      if(vmnvm.orientation == 'portrait') {
        displayRes = '-360x640.jpg'
      }
      var res = ['1080p','720p','360p'];
      var thumb;
      var maxRes;
      if(videoObj.image_urls) {
        for(var i=0;i<res.length;i++) {
          if(videoObj.image_urls[res[i]]) {
            thumb = videoObj.image_urls[res[i]];
            maxRes = res[i]
            break
          }
        }
      }
      vmnvm.date = getSubstringBetween(thumb, vmnvm.config.mediaoutcast.project_id, videoObj.hash);
      if(maxRes =='360p') {
        vmnvm.thumbsLocked.push(vmnvm.config.mediaoutcast.default_image[vmnvm.orientation])
      } else {
        vmnvm.thumbsLocked.push('/images'+ vmnvm.date + videoObj.hash + '/' +maxRes+'.jpg')
      }
      vmnvm.thumbs = angular.copy(vmnvm.thumbsLocked);
      vmnvm.mp4 = getSubstringBetween(videoObj.published_mp4_url,vmnvm.config.mediaoutcast.project_id);
      vmnvm.m3u8 = getSubstringBetween(videoObj.published_url,vmnvm.config.mediaoutcast.project_id);
      vmnvm.duration = videoObj.length;
      vmnvm.filename = videoObj.title;
      for(var i=0; i<vmnvm.thumbs.length;i++) {
          vmnvm.thumbs[i]=vmnvm.config.baseVideoHref + vmnvm.thumbs[i].replace('.jpg',displayRes); 
          vmnvm.thumbsLoaded[i]=false;
          vmnvm.thumbsLoaded.all=false;
      }
      if(vmnvm.uploadVideoObj.id && vmnvm.mp4 && vmnvm.m3u8 && videoObj.hash) {
        vmnvm.uploaded = true;
      }
      var thumbLoaded = 0
      var imageThumbElement;
      function loadThumbs() {
        imageThumbElement = angular.element(document.getElementsByClassName('thumb-uploading'));
        for(var i = 0; i<imageThumbElement.length;i++) {
          imageThumbElement[i].src = undefined;
          imageThumbElement[i].src = vmnvm.thumbs[i]
          jQuery(imageThumbElement[i]).off('load').on('load',function(i) {
              var index = jQuery(this).attr('index');
              thumbLoaded++
              $scope.$apply(function() {
                  vmnvm.thumbsLoaded[index] = true;
              })
              if(thumbLoaded==imageThumbElement.length) {
                  $scope.$apply(function() {
                    $interval.cancel(loadedInterval);
                    loadedInterval = null
                    vmnvm.thumbsLoaded.all = true;
                    vmnvm.selectedImage = 0;
                    vmnvm.image = vmnvm.thumbsLocked[0];
                    vmnvm.thumbRequired = false;
                  })
              }
          }); 
        }
      }
      $timeout(function() {
        loadThumbs()
      },100)
      loadedInterval = $interval(function(){
        loadThumbs()
      },2000)
    }
    vmnvm.dzOptionsThumb = {
        url : 'https://upload.telegraf.tv/api/mediaoutcast/thumb/update',
        paramName : 'filename',
        maxFilesize : '500000',
        parallelUploads: 1,  
        acceptedFiles : 'image/jpeg, images/jpg',
        addRemoveLinks : true,
        autoProcessQueue : false,
        dictInvalidFileType: 'This file type is not supported.',
        dictFileTooBig:'File size too Big',
        dictDefaultMessage : "Drop image here to upload",
        headers:{
          'x-auth': null  
        },      
    };
    vmnvm.dzCallbacksThumb = {
        'addedfile' : function(file){
          fileReaderImage(file,function(width,height){
            if (((vmnvm.orientation=='portrait') &&  (width < 541 || height < 961)) || 
            ((vmnvm.orientation!='portrait') &&  (width < 816 || height < 459))) {
              vmnvm.dzMethodsThumb.removeFile(file);
              var imageDimensions = (vmnvm.orientation=='portrait')? '541x961':'816x459'
							alertService('danger','Opps! ', "Image dimensions are too small (min-dimensions:"+ imageDimensions +"). The file has been removed.");
            } else {
              uploadFile()
            }
          })
          function uploadFile() {
            vmnvm.newFileThumb = file;
            var promise = refreshtokenService.getAccessToken();
            promise.then(
              function(answer) {
                    var token = authtokenService.getToken();
                    vmnvm.dzOptionsThumb.headers['x-auth'] = token;
                    vmnvm.dzMethodsThumb.processQueue();
              },
              function(error) {
                // report something
              },
              function(progress) {
              // report progress
            });
          }
            
        },
        'success' : function(file, xhr, response){
            var data = JSON.parse(response.currentTarget.response);
            vmnvm.customThumb = data.image;
            vmnvm.customThumbsLocked = angular.copy(data.image);
            vmnvm.uploadedThumb = true;
            if(vmnvm.thumbsLocked.length != vmnvm.thumbs.length) { 
              vmnvm.thumbs.splice(-1,1);
            }
            vmnvm.thumbs.push(vmnvm.config.baseVideoHref + vmnvm.customThumb.replace('.jpg',displayRes));
            vmnvm.thumbsLoaded[vmnvm.thumbs.length-1] = false;
            vmnvm.selectedImage = vmnvm.thumbs.length-1;
            vmnvm.thumbRequired = false;
            vmnvm.image = vmnvm.customThumbsLocked;
        },
        'error' : function(response,message) {
        },
        'sending':function(file, xhr, formData) {
          formData.append('video_id',vmnvm.uploadVideoObj.id);
        }
    };
    // Apply methods for dropzone
    // Visit http://www.dropzonejs.com/#dropzone-methods for more methods
    // vmnvm.dzMethods = {
    //     'init': function() {
          
    //     }
    // };
    vmnvm.updateSafety = function(safeId, checked) {
      if(checked) {
        for(var i = 0; i<vmnvm.addSafety.length;i++) {
          vmnvm.checkedItems[vmnvm.addSafety[i]._id] = false
        }
        vmnvm.checkedItems[safeId]= true;
        vmnvm.safe = safeId;  
      } else {
        vmnvm.safe = null;
      }
    }
    var addNewTagFunction = function(data) {
      vmnvm.newTagRequired = false;
      if(!checkArray.contains.call(vmnvm.tags,data.tagId)) {
        vmnvm.tags.push(data.tagId);
        vmnvm.searchtagfocus = null;
        vmnvm.existTag = false;
      } else {
        vmnvm.existTag = true;
      }
    }
    $scope.$on('select-tag', function(event,data) {
      addNewTagFunction(data.selectedTagObj)
    });
    vmnvm.addNewTag = function() {
      if(vmnvm.searchtagfocus && vmnvm.searchtagfocus.length>1) {
        var postFunction = function() {
          postDataService.save({
            param1:'video-tags', 
            // param2: 'create'
          },{
            'name': vmnvm.searchtagfocus
          }).$promise.then(function(postTag){
          var data = {
            tagId:postTag.tag._id,
            tagname: postTag.tag.name
          } 
            addNewTagFunction(data);
          }, function(error){
            if(!window.navigator.onLine) {
              offlineError()
              alertService('danger','Opps! ', 'Please check your internet connection and try again.');
              return
            }
            if(error.status ==401) {
              var promise = refreshtokenService.getAccessToken();
              promise.then(
                function(answer) {
                  if(answer==200) {   
                    postFunction();
                  }
                },
                function(error) {
                },
                function(progress) {
                 // report progress
              });
            } else if(error.status ==502) {
              serverError()
            } else if(error.status ==400) {
              var data = {
                tagId:error.data.tag._id,
                tagname: error.data.tag.name
              } 
              addNewTagFunction(data);
            }
          });
        }
        postFunction();
      } else {
        vmnvm.newTagRequired = true;
      }
    }
    vmnvm.removeFromTagsList = function(index) {
      vmnvm.tags.splice(index, 1);
    }

    var getVideoCategoriesFunction = function() {
        getDataService.get({param1: 'video-categories', tree:1}).$promise.then(function(dataCategory){
            vmnvm.categories = dataCategory.categories;
            vmnvm.categoriesTreeInput = reqursiveService.getReqursiveArray(vmnvm.categories);
        }, function(error){
          if(!window.navigator.onLine) {
            offlineError()
            $rootScope.hasLoaded = true;
            return
          }
          if(error.status ==401) {
            var promise = refreshtokenService.getAccessToken();
            promise.then(
                function(answer) {
                  if(answer==200) {
                    getVideoCategoriesFunction();
                  }
              },
              function(error) {
                // report something
              },
              function(progress) {
               // report progress
            });
          } else if(error.status ==502) {
            serverError()
          } else {
            alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
          }
          $rootScope.hasLoaded = true;
        });
    }  
    getVideoCategoriesFunction();
     vmnvm.updateSelection = function(category_id, checked) {
      var updateSelectionTree = function(categories) {
        if(checked) {
          for (var i=0; i<categories.length; i++){
            if (categories[i]._id !== category_id) {
              vmnvm.categorychecked.item[categories[i]._id] = false;
            }
          }
          vmnvm.category = category_id;
        } else {
          vmnvm.category = null;
        }
      }
      updateSelectionTree(vmnvm.categoriesTreeInput);   
    }
    vmnvm.saveVideos = function() {
        var validation = true;
        if(vmnvm.titleExceed) {
          validation = false;
          alertService('danger','Opps! ', 'Maximum number of characters in title is 100');
        }
        if(!vmnvm.uploaded) {
          validation = false;
          alertService('danger','Opps! ', 'Video has not been uploaded and transcoded yet.');
        }
        if(!vmnvm.upload_title) {
            validation = false;
            vmnvm.titleRequired = true;
        } else {
            vmnvm.titleRequired = false;
        }
        if(vmnvm.tags.length == 0) {
            validation = false;
            vmnvm.tagsRequired = true;
        } else {
            vmnvm.tagsRequired = false;
        }
        if(!vmnvm.category) {
            validation = false;
            vmnvm.categoryRequired = true;
        } else {
            vmnvm.categoryRequired = false;
        }
        if(!vmnvm.image) {
            vmnvm.thumbRequired = true;
            validation = false;
        } else {
            vmnvm.thumbRequired = false;
        }
        if(!vmnvm.safe) {
          vmnvm.videoSafeRequired = true;
          validation = false;
        } else {
          vmnvm.videoSafeRequired = false;
        }
        var updateFunction = function() {
            $rootScope.hasLoaded = false;
            var url = API_URL + state + '/mediaoutcast/' + vmnvm.videoNew._id;
            var videoData = {
              'video_id':vmnvm.uploadVideoObj.id,
              'hash': vmnvm.uploadVideoObj.hash,
              'title': (vmnvm.upload_title)? (vmnvm.upload_title).replace(/\r?\n|\r/g, ' '): '',
              'subtitle': (vmnvm.upload_subtitle)? (vmnvm.upload_subtitle).replace(/\r?\n|\r/g, ' '): '',
              'category':vmnvm.category,
              'tags': vmnvm.tags,
              'file': {
                'mp4': vmnvm.mp4,
                'm3u8': vmnvm.m3u8
              },
              'filename': vmnvm.filename,
              'image': vmnvm.image,
              'custom_image':vmnvm.customThumb,
              'thumbs':vmnvm.thumbsLocked,
              'signature':vmnvm.upload_signature,
              'status': 'draft',
              'meta':{
                'safe':vmnvm.safe
              },
              'allowance':vmnvm.geoAllow,
              'encodingId': '',
              'duration':vmnvm.duration,
              'transcoding_status': 1,
              "width":vmnvm.uploadVideoObj.width,
              "height": vmnvm.uploadVideoObj.height,
              "orientation": vmnvm.orientation
            }
  
            $http.put(url , videoData)
            .success(function (data, stat, headers) {
                $rootScope.hasLoaded = true;
                $state.go('app.allvideos', {id:vmnvm.videoNew._id});
                alertService('success','Success ', data.message, 2000);   
            })
            .error(function (data, status, header, config) {
              if(!window.navigator.onLine) {
                offlineError()
                $rootScope.hasLoaded = true;
                alertService('danger','Opps! ', 'Please check your internet connection and try again.');
                return
              }
              if(status ==401) {
                  var promise = refreshtokenService.getAccessToken();
                  promise.then(
                    function(answer) {
                      if(answer==200) {   
                        updateFunction();
                      }
                    },
                    function(error) {
                    },
                    function(progress) {
                      // report progress
              });
              }else if(status ==502) {
                  serverError()  
              }else { 
                  alertService('danger','Opps! ', (data && data.error && data.error.message)? data.error.message:'Failed to load response data.');
              }
              $rootScope.hasLoaded = true;
            }); 
        }    
        if(validation) {
            updateFunction();
        }
    }
    $scope.$on("$destroy", function() {
        $interval.cancel(loadedInterval);
        loadedInterval = null
    });
  }	
}



//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/videoModule/new-video/js/newVideoMediaoutcastController.js
// module id = 646
// module chunks = 0